import { render, staticRenderFns } from "./ScheduledFbPostsPage.vue?vue&type=template&id=acde3870&"
import script from "./ScheduledFbPostsPage.vue?vue&type=script&lang=js&"
export * from "./ScheduledFbPostsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports